import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';
import { WISHLIST_ADD_ENTRY, WISHLIST_ENTRY_LIST, WISHLIST_REMOVE_ENTRY, WishlistState } from '../wishlist-state';
import { wishlistEntryListValueReducer } from './entity-list.reducer';

export type WishlistReducers = WishlistState;

export function getReducers(): ActionReducerMap<WishlistReducers> {
  return {
    entryList: StateUtils.loaderReducer<WishlistEntry[]>(WISHLIST_ENTRY_LIST, wishlistEntryListValueReducer),
    addEntry: StateUtils.entityLoaderReducer<WishlistEntry>(WISHLIST_ADD_ENTRY),
    removeEntry: StateUtils.entityLoaderReducer<WishlistEntry>(WISHLIST_REMOVE_ENTRY),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<WishlistReducers>> = new InjectionToken<
  ActionReducerMap<WishlistReducers>
>('WishlistReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
